import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { t } from '@lingui/core/macro';
import { PageHeader } from '@/common/components/page-header/PageHeader.tsx';
import { Trans } from '@lingui/react/macro';
import { DispenserForm } from '@/features/dispensers/components/dispenser-form/DispenserForm.tsx';

import Stack from '@mui/material/Stack';
import { collectorQueries } from '@/features/collectors/queries.ts';
import { posQueries } from '@/features/pos/queries.ts';
import { producerQueries } from '@/features/producers/queries.ts';
import { DispenserFormOutput } from '@/features/dispensers/components/dispenser-form/config.ts';
import { DispenserService } from '@/features/dispensers/services/DispenserService.ts';
import { useQueryClient } from '@tanstack/react-query';
import { dispenserQueryKeys } from '@/features/dispensers/queries.ts';
import { FormPageSkeleton } from '@/common/components/loading-skeleton/FormPageSkeleton.tsx';

export const Route = createFileRoute('/dispensers/new')({
  component: RouteComponent,
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.ensureQueryData(collectorQueries.list()),
      context.queryClient.ensureQueryData(posQueries.list()),
      context.queryClient.ensureQueryData(producerQueries.list()),
    ]);

    return {
      breadcrumb: t`Create Dispenser`,
    };
  },
  pendingComponent: FormPageSkeleton,
});

function RouteComponent() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSubmit = async (values: DispenserFormOutput) => {
    await DispenserService.create({
      ...values,
    });
    await queryClient.invalidateQueries({ queryKey: dispenserQueryKeys.list() });
    await navigate({ to: '/dispensers', ignoreBlocker: true });
  };

  const handleCancel = () => {
    void navigate({ to: '/dispensers' });
  };

  return (
    <Stack gap={4}>
      <PageHeader
        title={<Trans>Create New Dispenser</Trans>}
        subtitle={<Trans>Add new paint dispensing machine to the system</Trans>}
      />
      <DispenserForm onSubmit={handleSubmit} onCancel={handleCancel} />
    </Stack>
  );
}
